var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CareAppListActionFactory } from "./action-factory";
var CustomerActionFactory = /** @class */ (function (_super) {
    __extends(CustomerActionFactory, _super);
    function CustomerActionFactory() {
        return _super.call(this, "Customers") || this;
    }
    Object.defineProperty(CustomerActionFactory.prototype, "REQUEST_ADD_CUSTOMER_FILE", {
        get: function () {
            return "[" + this.type + "][Request] Add Customer File";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerActionFactory.prototype, "RESPONSE_SUCCESS_ADD_CUSTOMER_FILE", {
        get: function () {
            return "[" + this.type + "][Response][Success] Add Customer File";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerActionFactory.prototype, "RESPONSE_FAIL_ADD_CUSTOMER_FILE", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Add Customer File";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerActionFactory.prototype, "REQUEST_BULK_ADD_CUSTOMERS", {
        get: function () {
            return "[" + this.type + "][Request] Bulk Add Customers";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerActionFactory.prototype, "PROGRESS_BULK_ADD_CUSTOMERS", {
        get: function () {
            return "[" + this.type + "][Progress] Bulk Add Customers";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerActionFactory.prototype, "RESPONSE_SUCCESS_BULK_ADD_CUSTOMERS", {
        get: function () {
            return "[" + this.type + "][Response][Success] Bulk Add Customers";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerActionFactory.prototype, "RESPONSE_FAIL_BULK_ADD_CUSTOMERS", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Bulk Add Customers";
        },
        enumerable: true,
        configurable: true
    });
    CustomerActionFactory.prototype.RequestAddCustomerFile = function (payload) {
        return {
            type: this.REQUEST_ADD_CUSTOMER_FILE,
            payload: payload
        };
    };
    CustomerActionFactory.prototype.ResponseSuccessAddCustomerFile = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_ADD_CUSTOMER_FILE,
            payload: payload
        };
    };
    CustomerActionFactory.prototype.ResponseFailAddCustomerFile = function (payload) {
        return {
            type: this.RESPONSE_FAIL_ADD_CUSTOMER_FILE,
            payload: payload
        };
    };
    CustomerActionFactory.prototype.RequestBulkAddCustomers = function (payload) {
        return {
            type: this.REQUEST_BULK_ADD_CUSTOMERS,
            payload: payload
        };
    };
    CustomerActionFactory.prototype.ProgressBulkAddCustomers = function (payload) {
        return {
            type: this.PROGRESS_BULK_ADD_CUSTOMERS,
            payload: payload
        };
    };
    CustomerActionFactory.prototype.ResponseSuccessBulkAddCustomers = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_BULK_ADD_CUSTOMERS,
            payload: payload
        };
    };
    CustomerActionFactory.prototype.ResponseFailBulkAddCustomers = function (payload) {
        return {
            type: this.RESPONSE_FAIL_BULK_ADD_CUSTOMERS,
            payload: payload
        };
    };
    return CustomerActionFactory;
}(CareAppListActionFactory));
export { CustomerActionFactory };
export var Customers = new CustomerActionFactory();
